import { stringify } from 'qs';
import { useSelector } from 'react-redux';
import type { VFC } from 'react';

import { exceptionsEnabledCategories, isProjectScope, isReleaseGroupScope } from '../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { icons } from '../../generic';
import { BUTTON_SIZE, NavigationButton } from '../../generic/Button';

import IssuesSearch from './IssuesSearch';

import css from './IssuesInboxHeader.module.less';

/**
 * The header for the issues inbox, containing search and the link to the ignore rules.
 */
const IssuesInboxHeader: VFC = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  const isComparisonModeOn = useSelector(IssuesV2Store.selectors.getComparisonMode);
  const pathname = window.location.pathname;

  const filters = useSelector(
    IssuesV2Store.selectors.getHydrateStateQuery,
  );

  const canDisplayIssueComparison = isProjectScope(scope) || isReleaseGroupScope(scope);

  return (
    <div className={css.header}>
      <div className={css.search}>
        <IssuesSearch />
      </div>
      <div className={css.buttons}>
        {!isComparisonModeOn && (
          <>
            {exceptionsEnabledCategories.includes(category) &&
              <NavigationButton to={`${pathname}/exceptions`} type="secondary" size={BUTTON_SIZE.MEDIUM}>Ignore Rules</NavigationButton> }
            {canDisplayIssueComparison && (
              <NavigationButton to={`${pathname}/compare?${stringify(filters)}`} type="secondary" size={BUTTON_SIZE.MEDIUM} icon={icons.codeCompare}>Compare</NavigationButton>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default IssuesInboxHeader;
